import { type FC, useId } from "react";
import SearchSuggestionListItem from "./SearchSuggestionListItem";

interface SearchSuggestionListProps {
  suggestions: string[];
  onClick: (suggestion: string) => void;
}

const SearchSuggestionList: FC<SearchSuggestionListProps> = ({ suggestions, onClick }) => {
  const id = useId();

  if (suggestions.length === 0) {
    return null;
  }

  return (
    <ul className="flex flex-col gap-y-2 text-sm">
      {suggestions.map((suggestion, i) => (
        <SearchSuggestionListItem
          key={`${id}-${i}`}
          suggestion={suggestion}
          onClick={onClick}
        />
      ))}
    </ul>
  );
};

export default SearchSuggestionList;
